const seoData = {
  // ============================================================
  // HOMEPAGE — Primary keywords + authority + geo
  // ============================================================
  home: {
    title: null,
    description: 'BCS is a certified industrial coating contractor and corrosion repair specialist serving California. Tank coating, water tank lining, wastewater coatings, clarifier repair, secondary containment, epoxy repair systems, and infrastructure rehabilitation. WBENC certified. 24/7 emergency response.',
    keywords: [
      // Core primary
      'industrial coating contractor', 'tank coating contractor', 'water tank lining contractor',
      'corrosion repair contractor', 'wastewater coating contractor', 'epoxy repair systems',
      'protective coatings contractor', 'clarifier coating repair', 'secondary containment coatings',
      'infrastructure rehabilitation contractor',
      // Authority
      'industrial coating experts', 'corrosion specialists contractor', 'infrastructure repair experts',
      'coating systems specialists', 'turnkey coating contractor', 'full service coating contractor',
      // Geo
      'industrial coating contractor California', 'corrosion repair contractor California',
      'tank coating contractor California', 'industrial coating contractor Southern California',
      // Industry
      'municipal coating contractor', 'public works coating contractor', 'water district contractor',
      // WBENC
      'WBENC certified contractor', 'woman-owned industrial contractor',
      // Long-tail
      'industrial tank coating contractor near me', 'protective coatings contractor for water facilities',
      'industrial coating contractor for municipalities'
    ]
  },

  // ============================================================
  // SERVICES
  // ============================================================
  'services/equipment-repair': {
    title: 'Industrial Equipment Repair & Pump Restoration Contractor',
    description: 'Industrial equipment repair contractor in California. Pump restoration, bearing housing rebuild, impeller repair, rotating equipment services. Epoxy repair systems, no hot work, in-situ mechanical system repair. Extend asset service life.',
    keywords: [
      'mechanical system repair contractor', 'industrial asset restoration', 'extend asset service life',
      'epoxy repair systems', 'industrial epoxy repair', 'pump repair contractor',
      'bearing housing repair', 'rotating equipment repair', 'industrial maintenance coatings',
      'plant maintenance contractor', 'corrosion repair services',
      'industrial equipment repair California', 'equipment repair contractor Southern California'
    ]
  },
  'services/protective-coatings': {
    title: 'Protective Coatings Contractor | Industrial Coating Services California',
    description: 'Protective coatings contractor serving California. Industrial coating services including epoxy, polyurethane, corrosion protection coatings, high performance coatings, immersion grade coatings, and chemical resistant coating systems for tanks, pipes, and infrastructure.',
    keywords: [
      // Core
      'protective coatings contractor', 'industrial coating contractor', 'industrial coating services',
      'protective coating systems', 'epoxy coating contractor', 'industrial epoxy coatings',
      'corrosion protection coatings', 'steel coating contractor', 'concrete coating contractor',
      // Product/system
      'high performance coatings', 'immersion grade coatings', 'corrosion resistant coatings',
      'chemical resistant coatings', 'abrasion resistant coatings', 'high build epoxy coatings',
      'polyurea coatings contractor', 'polyurethane coatings industrial',
      // Pain point
      'protective coatings for corrosion', 'stop corrosion infrastructure',
      // Geo
      'protective coatings contractor California', 'industrial coating contractor California',
      'industrial coating contractor Southern California'
    ]
  },
  'services/pipeline-repair': {
    title: 'Pipeline Coating & Pipe Rehabilitation Contractor California',
    description: 'Pipeline coating contractor and pipe rehabilitation services in California. Industrial pipe repair, pipe lining, composite wraps, leak sealing. ISO 24817 / ASME PCC-2 compliant. No hot work, no shutdown required.',
    keywords: [
      'pipeline coating contractor', 'pipe rehabilitation contractor', 'pipe lining contractor',
      'industrial pipe repair', 'pipe leak sealing', 'composite pipe wrap',
      'corrosion repair contractor', 'no hot work pipe repair',
      'pipeline coating contractor California', 'pipe repair contractor Southern California'
    ]
  },
  'services/structural-repair': {
    title: 'Concrete Rehabilitation & Structural Repair Contractor California',
    description: 'Concrete rehabilitation contractor serving California. Structural concrete repair, spall repair, epoxy concrete repair, concrete crack injection, concrete resurfacing. Infrastructure rehabilitation for industrial and municipal facilities.',
    keywords: [
      // Core structural
      'concrete rehabilitation contractor', 'structural concrete repair', 'spall repair contractor',
      'epoxy concrete repair', 'concrete crack injection', 'concrete resurfacing contractor',
      'infrastructure rehabilitation contractor',
      // Pain point
      'repair deteriorated concrete', 'fix wastewater tank damage',
      // Geo
      'concrete repair contractor California', 'structural repair contractor Southern California',
      'infrastructure rehabilitation contractor California'
    ]
  },
  'services/hvac-repair': {
    title: 'HVAC & Chiller Repair | Cooling Tower Coating Contractor',
    description: 'HVAC, chiller, and cooling tower repair and coating services. Tubesheet coating, condenser repair, cooling tower media fill replacement. Industrial maintenance contractor in California.',
    keywords: [
      'HVAC repair contractor', 'chiller repair', 'cooling tower coating',
      'condenser repair', 'tubesheet coating', 'industrial maintenance coatings',
      'plant maintenance contractor', 'HVAC coating contractor California'
    ]
  },
  'services/tank-repair': {
    title: 'Tank Coating Contractor | Water Tank Lining & Repair California',
    description: 'Tank coating contractor and water tank lining specialist in California. Water tank repair, storage tank lining, steel tank coating, elevated tank coating, ground storage tank coating, tank interior lining. NSF 61 potable water coatings. Fix corroded steel tank.',
    keywords: [
      // Core tank
      'tank coating contractor', 'water tank lining contractor', 'water tank coating contractor',
      'water tank repair contractor', 'storage tank lining contractor', 'steel tank coating services',
      'elevated tank coating', 'ground storage tank coating', 'tank interior lining contractor',
      'tank exterior coating contractor',
      // Product
      'NSF 61 coating contractor', 'potable water coatings', 'epoxy tank lining', 'epoxy lining systems',
      // Pain point
      'fix corroded steel tank', 'repair leaking water tank', 'tank failure prevention',
      // Geo
      'tank coating contractor California', 'water tank lining contractor California',
      'tank coating contractor Los Angeles', 'tank coating contractor Southern California'
    ]
  },
  'services/grease-interceptors': {
    title: 'Grease Interceptor Repair & Rehabilitation Contractor | BCS',
    description: 'Professional grease interceptor repair, rehabilitation, and protective coating services nationwide. Restore corroded, leaking, or deteriorated grease traps with Belzona-engineered coatings and a 5-year warranty.',
    keywords: [
      'grease interceptor repair', 'grease trap rehabilitation', 'grease interceptor coating',
      'restaurant grease trap repair', 'concrete grease interceptor restoration',
      'grease interceptor lining', 'grease interceptor protective coating',
      'H2S corrosion grease trap', 'FOG interceptor repair', 'commercial grease trap repair',
      'Belzona grease interceptor', 'grease interceptor contractor California',
      'grease interceptor contractor nationwide', 'food service grease trap repair'
    ]
  },
  'services/floor-repair': {
    title: 'Industrial Floor Coating Contractor | Heavy Duty Flooring',
    description: 'Industrial floor coating contractor in California. Heavy duty industrial flooring, slip resistant industrial coatings, epoxy floor systems, safety striping for manufacturing, warehouses, and industrial facilities.',
    keywords: [
      'industrial floor coatings heavy duty', 'slip resistant industrial coatings',
      'epoxy floor contractor', 'industrial flooring contractor', 'resinous floor systems',
      'manufacturing facility coatings', 'industrial floor coating California'
    ]
  },
  'services/roof-repair': {
    title: 'Industrial Roof Coating & Waterproofing Contractor',
    description: 'Industrial roof repair, leak sealing, and membrane encapsulation. Waterproofing solutions for metal, concrete, and membrane roofs. Protective coating systems for industrial facilities in California.',
    keywords: [
      'industrial roof repair', 'roof waterproofing contractor', 'roof coating contractor',
      'roof leak sealing', 'membrane encapsulation', 'industrial roof coating California'
    ]
  },
  'services/asset-life-extension': {
    title: 'Asset Life Extension | Industrial Asset Restoration Services',
    description: 'Extend asset service life with protective coatings, corrosion repair, and infrastructure rehabilitation. Reduce capital expenditure with in-situ repair. Industrial asset restoration contractor in California.',
    keywords: [
      'extend asset service life', 'industrial asset restoration', 'tank failure prevention',
      'infrastructure rehabilitation contractor', 'asset life extension', 'corrosion repair services',
      'asset life extension California'
    ]
  },
  'services/industrial-cleaning': {
    title: 'Surface Preparation & Media Blasting Contractor',
    description: 'Industrial surface preparation and media blasting contractor in California. Abrasive blasting, pressure washing, and chemical cleaning for coating applications on tanks, pipes, and infrastructure.',
    keywords: [
      'surface preparation contractor', 'media blasting contractor', 'abrasive blasting',
      'industrial cleaning contractor', 'surface preparation California'
    ]
  },
  'services/engines-casings': {
    title: 'Engine & Casing Repair | Epoxy Rebuild Contractor',
    description: 'Engine and casing repair using epoxy rebuild systems. Restore worn housings, casings, and engine components to OEM specifications without welding. Industrial mechanical repair contractor.',
    keywords: [
      'engine repair contractor', 'casing repair', 'epoxy rebuild',
      'mechanical system repair contractor', 'industrial epoxy repair'
    ]
  },
  'services/fans-blowers': {
    title: 'Fan & Blower Repair | Erosion Protection Contractor',
    description: 'Industrial fan and blower repair. Erosion protection, impeller rebuild, and housing restoration. Abrasion resistant coatings for industrial air handling equipment.',
    keywords: [
      'fan repair contractor', 'blower repair', 'erosion protection',
      'abrasion resistant coatings', 'impeller rebuild'
    ]
  },
  'services/gaskets-seals': {
    title: 'Gasket & Seal Solutions | Emergency Gasket Fabrication',
    description: 'Custom gasket and seal solutions for industrial equipment. Emergency gasket fabrication and flange face repair using epoxy systems. Industrial repair contractor.',
    keywords: [
      'gasket solutions', 'seal repair', 'flange face repair',
      'emergency gasket fabrication', 'industrial repair contractor'
    ]
  },
  'services/solids-handling': {
    title: 'Solids Handling Equipment Repair & Erosion Protection',
    description: 'Repair and protection for solids handling equipment. Erosion and abrasion resistant coatings for hoppers, chutes, cyclones, and conveyors in mining, quarrying, and industrial facilities.',
    keywords: [
      'solids handling repair', 'hopper coating', 'erosion protection',
      'abrasion resistant coatings', 'chute lining', 'industrial coating contractor'
    ]
  },
  'services/mechanical-transmission': {
    title: 'Mechanical Transmission Repair | Shaft Rebuild Contractor',
    description: 'Mechanical transmission and power system repair. Shaft rebuilding, keyway repair, bearing seat restoration using cold-applied epoxy systems. No hot work required.',
    keywords: [
      'transmission repair', 'shaft rebuild', 'keyway repair',
      'mechanical system repair contractor', 'bearing seat restoration'
    ]
  },
  'services/marine-offshore': {
    title: 'Marine & Offshore Coating Contractor California',
    description: 'Marine and offshore coating and repair services. Corrosion protection for vessels, platforms, and port infrastructure. Chemical resistant coatings for marine environments. California marine contractor.',
    keywords: [
      'marine coating contractor', 'offshore coatings', 'marine corrosion protection',
      'vessel repair', 'chemical resistant coatings', 'marine coating contractor California'
    ]
  },

  // ============================================================
  // INDUSTRIES
  // ============================================================
  'industries/oil-gas': {
    title: 'Oil & Gas Coating Contractor | Refinery Corrosion Repair',
    description: 'Industrial coating contractor for oil and gas facilities. Refinery coating, pipeline corrosion repair, tank lining, secondary containment coatings. Protective coating systems for upstream, midstream, and downstream operations.',
    keywords: [
      'refinery coating contractor', 'oil and gas coating contractor', 'pipeline coating contractor',
      'secondary containment coatings', 'corrosion repair contractor', 'tank lining contractor',
      'industrial coating contractor', 'chemical resistant coatings',
      'refinery coating contractor California'
    ]
  },
  'industries/water-wastewater': {
    title: 'Wastewater Coating Contractor | Water Tank Lining & Clarifier Repair',
    description: 'Wastewater coating contractor and water tank lining specialist. Clarifier coating repair, wet well coating, sewage tank lining, treatment plant coatings, secondary containment. NSF 61 potable water coatings. Municipal and water district contractor in California.',
    keywords: [
      // Core wastewater
      'wastewater coating contractor', 'wastewater tank coating', 'clarifier coating contractor',
      'clarifier repair contractor', 'clarifier coating repair', 'wastewater facility coatings',
      'treatment plant coating contractor', 'wet well coating contractor', 'sewage tank lining',
      // Water tank
      'water tank lining contractor', 'water tank coating contractor', 'water tank repair contractor',
      'NSF 61 coating contractor', 'potable water coatings',
      // Municipal
      'municipal coating contractor', 'public works coating contractor', 'water district contractor',
      'city infrastructure repair contractor',
      // Secondary containment
      'secondary containment coatings', 'secondary containment lining contractor',
      'containment coating systems', 'chemical containment coatings',
      // Pain point
      'fix wastewater tank damage', 'repair leaking water tank', 'tank failure prevention',
      // Long tail
      'wastewater clarifier coating repair contractor', 'protective coatings contractor for water facilities',
      // Geo
      'wastewater coating contractor California', 'water tank lining contractor California',
      'wastewater coating contractor San Diego', 'clarifier repair contractor Southern California'
    ]
  },
  'industries/power': {
    title: 'Power Plant Coating Contractor | Power Generation Repair',
    description: 'Coating and corrosion repair for power generation facilities. Cooling tower coating, condenser repair, boiler protection, and corrosion prevention for power plants. Industrial coating contractor California.',
    keywords: [
      'power plant coating contractor', 'power generation coating', 'cooling tower coating',
      'condenser coating', 'industrial coating contractor', 'corrosion repair contractor',
      'power plant coating contractor California'
    ]
  },
  'industries/manufacturing': {
    title: 'Manufacturing Facility Coatings | Industrial Maintenance Contractor',
    description: 'Industrial coating and maintenance services for manufacturing facilities. Floor coatings, equipment repair, corrosion protection, and plant maintenance. Manufacturing facility coating contractor California.',
    keywords: [
      'manufacturing facility coatings', 'industrial maintenance coatings', 'plant maintenance contractor',
      'industrial floor coatings heavy duty', 'industrial coating contractor',
      'manufacturing facility coatings California'
    ]
  },
  'industries/petrochemical': {
    title: 'Petrochemical Coating Contractor | Chemical Resistant Coatings',
    description: 'Coating and repair for petrochemical plants. Chemical resistant coatings, immersion grade coatings, tank lining, and pipeline repair for corrosive chemical environments.',
    keywords: [
      'petrochemical coating contractor', 'chemical resistant coatings', 'immersion grade coatings',
      'industrial coating contractor', 'tank lining contractor', 'corrosion repair contractor'
    ]
  },
  'industries/marine': {
    title: 'Marine Industry Coating Contractor | Vessel & Port Infrastructure',
    description: 'Marine coating and repair for vessels, ballast tanks, hulls, and port infrastructure. Corrosion resistant coatings for saltwater environments. Marine coating contractor California.',
    keywords: [
      'marine coating contractor', 'hull coating', 'ballast tank coating',
      'marine corrosion protection', 'corrosion resistant coatings',
      'marine coating contractor California'
    ]
  },
  'industries/mining-quarrying': {
    title: 'Mining & Quarrying Coating Contractor | Erosion Protection',
    description: 'Erosion and corrosion protection for mining and quarrying. Abrasion resistant coatings for hoppers, chutes, cyclones. Industrial coating contractor for mining operations.',
    keywords: [
      'mining coating contractor', 'quarrying equipment repair', 'erosion protection',
      'abrasion resistant coatings', 'industrial coating contractor'
    ]
  },
  'industries/pulp-paper': {
    title: 'Pulp & Paper Industry Coating & Corrosion Repair',
    description: 'Coating and corrosion repair for pulp and paper mills. Chemical resistant coatings, tank lining, and equipment repair for processing environments.',
    keywords: [
      'pulp paper coating contractor', 'paper mill repair', 'chemical resistant coatings',
      'industrial coating contractor', 'corrosion repair contractor'
    ]
  },
  'industries/food-drink': {
    title: 'Food & Beverage Coating Contractor | FDA Compliant Coatings',
    description: 'FDA-compliant coating and repair for food and beverage facilities. Hygienic floor coatings, tank linings, equipment repair, and corrosion protection.',
    keywords: [
      'food beverage coating contractor', 'FDA compliant coatings', 'hygienic floor coating',
      'industrial coating contractor', 'tank lining contractor'
    ]
  },
  'industries/pharmaceutical': {
    title: 'Pharmaceutical Facility Coating Contractor',
    description: 'Coating and repair for pharmaceutical manufacturing. Chemical resistant floor coatings, containment coatings, and clean room equipment repair.',
    keywords: [
      'pharmaceutical coating contractor', 'chemical resistant coatings', 'containment coating systems',
      'pharmaceutical floor coating', 'industrial coating contractor'
    ]
  },
  'industries/wind-power': {
    title: 'Wind Power Coating & Turbine Repair Contractor',
    description: 'Coating and repair for wind turbines and renewable energy infrastructure. Leading edge protection, tower coating, and foundation repair.',
    keywords: [
      'wind turbine repair', 'wind power coating', 'renewable energy contractor',
      'industrial coating contractor'
    ]
  },
  'industries/facilities-maintenance': {
    title: 'Facilities Maintenance Coating Contractor | Plant Maintenance',
    description: 'Full service facilities maintenance coating contractor. Industrial maintenance coatings, preventive maintenance programs, floor systems, and equipment repair for commercial and industrial facilities.',
    keywords: [
      'plant maintenance contractor', 'industrial maintenance coatings', 'facilities maintenance contractor',
      'full service coating contractor', 'industrial coating contractor'
    ]
  },
  'industries/steel': {
    title: 'Steel Industry Coating Contractor | High Temperature Coatings',
    description: 'Coating and repair for steel mills and metalworking facilities. High temperature coatings, steel coating, equipment repair, and corrosion protection.',
    keywords: [
      'steel coating contractor', 'high temperature coatings', 'steel mill coating',
      'industrial coating contractor', 'corrosion protection coatings'
    ]
  },
  'industries/waste-to-energy': {
    title: 'Waste-to-Energy Coating & Repair Contractor',
    description: 'Coating and repair for waste-to-energy plants. Corrosion and erosion protection for boilers, scrubbers, and material handling systems.',
    keywords: [
      'waste to energy coating', 'incinerator repair', 'scrubber coating',
      'erosion protection', 'industrial coating contractor'
    ]
  },
  'industries/agriculture-fishing': {
    title: 'Agriculture & Fishing Coating & Repair Contractor',
    description: 'Coating and repair for agriculture and fishing. Equipment protection, tank lining, and corrosion repair for demanding environments.',
    keywords: [
      'agriculture coating contractor', 'tank lining contractor', 'corrosion repair contractor'
    ]
  },
  'industries/general-industry': {
    title: 'Industrial Coating Contractor | Full Service Coating & Repair',
    description: 'Full service industrial coating contractor. Protective coatings, corrosion repair, tank lining, floor coatings, and infrastructure rehabilitation for all industries. Turnkey coating contractor California.',
    keywords: [
      'industrial coating contractor', 'full service coating contractor', 'turnkey coating contractor',
      'protective coatings contractor', 'corrosion repair contractor', 'infrastructure rehabilitation contractor',
      'industrial coating contractor California'
    ]
  },
  'industries/sugar': {
    title: 'Sugar Industry Coating & Erosion Protection Contractor',
    description: 'Coating and repair for sugar processing. Erosion protection, abrasion resistant coatings, tank lining, and equipment repair for abrasive environments.',
    keywords: [
      'sugar industry coating', 'erosion protection', 'abrasion resistant coatings',
      'industrial coating contractor'
    ]
  },
  'industries/education': {
    title: 'Education Facility Coating & Repair Contractor',
    description: 'Coating and repair for schools, colleges, and universities. Floor coatings, roof repair, tank coating, and facility maintenance.',
    keywords: [
      'education facility coating', 'school floor coating', 'institutional coating contractor'
    ]
  },
  'industries/hydrogen': {
    title: 'Hydrogen Facility Coating & Corrosion Protection Contractor',
    description: 'Coating and repair for hydrogen production and storage. Corrosion protection and chemical resistant coatings for emerging energy infrastructure.',
    keywords: [
      'hydrogen facility coating', 'chemical resistant coatings', 'corrosion protection coatings',
      'industrial coating contractor'
    ]
  },

  // ============================================================
  // ABOUT
  // ============================================================
  'about/why-choose-bcs': {
    title: 'Why Choose BCS | Turnkey Industrial Coating Contractor',
    description: 'Why choose BCS? Turnkey industrial coating contractor. No hot work, in-situ repairs, manufacturer warranties, WBENC certified, 25+ years experience. Full service coating contractor serving California.',
    keywords: [
      'turnkey coating contractor', 'full service coating contractor', 'industrial coating experts',
      'corrosion specialists contractor', 'WBENC certified contractor',
      'industrial coating contractor California'
    ]
  },
  'about/our-team': {
    title: 'Our Team | Industrial Coating Experts & Corrosion Specialists',
    description: 'Meet the BCS team of industrial coating experts and corrosion specialists. AMPP/NACE certified applicators. WBENC certified woman-owned business serving California.',
    keywords: [
      'industrial coating experts', 'corrosion specialists contractor', 'NACE certified',
      'WBENC certified contractor', 'coating systems specialists'
    ]
  },
  'about/our-experience': {
    title: 'Our Experience | 25+ Years Industrial Coating & Repair',
    description: 'BCS has 25+ years experience in industrial coating and corrosion repair. Over 1,000 projects across oil & gas, water treatment, manufacturing, municipal, and power generation.',
    keywords: [
      'industrial coating experience', 'corrosion repair track record',
      'infrastructure repair experts', 'industrial coating contractor'
    ]
  },
  'about/testimonials': {
    title: 'Customer Testimonials | Industrial Coating Contractor Reviews',
    description: 'Read what clients say about BCS industrial coating and corrosion repair services. Trusted by municipalities, water districts, and industrial facilities across California.',
    keywords: [
      'industrial coating contractor reviews', 'coating contractor testimonials',
      'municipal coating contractor', 'water district contractor'
    ]
  },
  'about/associations': {
    title: 'Industry Associations & Certifications',
    description: 'BCS industry memberships: AMPP/NACE, WBENC, and professional affiliations. Certified industrial coating contractor with municipal and federal credentials.',
    keywords: [
      'AMPP member', 'NACE certified', 'WBENC certified', 'industrial coating contractor'
    ]
  },
  'about/mission-statement': {
    title: 'Mission Statement | BCS — Industrial Repair & Corrosion Control',
    description: 'The BCS mission: extending the life of critical infrastructure and industrial equipment through innovative repair, restoration, and protective solutions — with integrity, excellence, and a commitment to God, Family, and Country.',
    keywords: [
      'BCS mission statement', 'industrial repair mission', 'corrosion control values',
      'infrastructure repair company values', 'God family country contractor'
    ]
  },

  // ============================================================
  // MAINTENANCE
  // ============================================================
  'maintenance/smart-program': {
    title: 'SMART Maintenance Program | Preventive Coating Maintenance',
    description: 'BCS SMART preventive maintenance program. Systematic inspections, active corrosion control, and protective coating maintenance to extend asset service life and prevent tank failure.',
    keywords: [
      'preventive maintenance program', 'industrial maintenance coatings', 'corrosion control',
      'extend asset service life', 'tank failure prevention', 'plant maintenance contractor'
    ]
  },

  // ============================================================
  // RESEARCH
  // ============================================================
  'research/corrosion-rust': {
    title: 'Corrosion & Rust Repair Solutions | Stop Corrosion Infrastructure',
    description: 'Industrial corrosion and rust repair solutions. Stop corrosion on infrastructure, tanks, pipes, and steel structures. Corrosion resistant coatings and epoxy repair systems.',
    keywords: [
      'corrosion repair services', 'stop corrosion infrastructure', 'corrosion resistant coatings',
      'protective coatings for corrosion', 'fix corroded steel tank', 'corrosion repair contractor'
    ]
  },
  'research/leaks-seepage': {
    title: 'Leak Repair & Seepage Solutions | Fix Leaking Water Tank',
    description: 'Industrial leak and seepage repair. Fix leaking water tanks, pipe leak sealing, containment solutions. Epoxy lining systems and composite wraps.',
    keywords: [
      'repair leaking water tank', 'pipe leak sealing', 'epoxy lining systems',
      'containment coating systems', 'tank failure prevention'
    ]
  },

  // ============================================================
  // OTHER
  // ============================================================
  belzona: {
    title: 'Belzona Products & Epoxy Repair Systems | Authorized Applicator',
    description: 'BCS is an authorized Belzona applicator. Belzona epoxy repair systems, protective coating systems, concrete repair, and elastomer solutions. Industrial epoxy repair contractor California.',
    keywords: [
      'Belzona applicator', 'Belzona contractor', 'epoxy repair systems', 'industrial epoxy repair',
      'industrial epoxy coatings', 'epoxy coating contractor', 'epoxy lining systems',
      'epoxy repair systems California'
    ]
  },
  careers: {
    title: 'Careers at BCS | Industrial Coating Jobs California',
    description: 'Join the BCS team. Career opportunities in industrial coating and corrosion repair. Skilled applicators, project managers, and support roles in California.',
    keywords: [
      'industrial coating jobs', 'coating applicator jobs California', 'BCS careers'
    ]
  }
};

export default seoData;
